import Link from "next/link";

import { colors } from "const/colors";
import { Article, Section, SectionSmall, Text } from "styles";

import RetractableSection from "../RetractableSection";

const faqs = [
	{
		title: "What's new in Wishbox 2.0?",
		body: "2.0 adds an AI assistant, collaboration on a specific item, richer widgets, and a faster data system — with the same local-first privacy. Android and Wear OS are coming with the same app. Wishbox+ unlocks the extra tools when you want them."
	},
	{
		title: "How is this different from a budget app?",
		body: "Wishbox labels money for a wish or a coming expense. You still log income and spending, but the point is to see what each pile of savings is for — not to rebuild a spreadsheet every month."
	},
	{
		title: "Do I have to connect a bank?",
		body: "No. Wishbox works with cash, wallets, and files you already have. You can import a CSV or ask the assistant to read a bank export. There is no required bank login."
	},
	{
		title: "Is my data on your servers?",
		body: "Not by default. Transactions and wishboxes stay on your device until you turn on collaboration, cloud sync, or the AI assistant."
	},
	{
		title: "What can the AI assistant do?",
		body: "Chat or speak to add transactions, import a bank export, catch duplicates, explain spending, and create or deposit into wishboxes. It only runs after you agree, and you can turn it off in Settings."
	},
	{
		title: "How does collaboration work?",
		body: "Invite someone to a specific item — a wallet, a house fund, or a trip. Only that item’s transactions stay in sync. Everything else stays on your device."
	},
	{
		title: "Which devices does Wishbox support?",
		body: "iPhone, iPad, Mac, and Apple Watch now. Android phones, tablets, and Wear OS are coming soon with the same Wishbox. Home screen widgets are on iPhone now, and the same widgets are coming on Android. Watch apps can log with voice and keep wishbox progress nearby."
	},
	{
		title: "What is Wishbox+?",
		body: "Wishbox+ unlocks collaboration, the AI assistant, richer widgets, multiple currencies, cloud sync, CSV export, and backup & restore. You can cancel anytime from the App Store or Google Play."
	},
	{
		title: "Can I import from another app?",
		body: "Yes. Use Settings → Import to match a CSV, or give the file to the AI assistant and ask it to import. The assistant can read a bank export or another app’s file and match the fields for you. You can fix anything that is not."
	},
	{
		title: "Does it work across my devices?",
		body: "Optionally. Cloud Sync stores a copy of your app database in your own iCloud or Google Drive. You can also backup and restore the full app state."
	},
	{
		title: "How do I cancel Wishbox+?",
		body: "On iPhone or iPad, manage the subscription in the App Store. On Android, manage it in Google Play."
	}
];

export default function HomeFaq() {
	return (
		<Section>
			<SectionSmall style={{ flexDirection: "column", width: "100%" }}>
				<Article>
					<Text midExtreme>
						<Text color={colors.yellow}>A few</Text> things people{" "}
						<Text color={colors.teal}>ask</Text>.
					</Text>
				</Article>
				{faqs.map(faq => (
					<RetractableSection key={faq.title} title={faq.title}>
						{faq.body}
					</RetractableSection>
				))}
				<Article style={{ paddingTop: 10 }}>
					<Text body>
						More answers live on the <Link href="/support">support page</Link>. Read the{" "}
						<Link href="/privacy">privacy policy</Link>.
					</Text>
				</Article>
			</SectionSmall>
		</Section>
	);
}
